function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, undefined, groups); }; var _super = RegExp.prototype; var _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); _groups.set(_this, groups || _groups.get(re)); return _setPrototypeOf(_this, BabelRegExp.prototype); } _inherits(BabelRegExp, RegExp); BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); if (result) result.groups = buildGroups(result, this); return result; }; BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if (typeof substitution === "string") { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } else if (typeof substitution === "function") { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; if (_typeof(args[args.length - 1]) !== "object") { args = [].slice.call(args); args.push(buildGroups(args, _this)); } return substitution.apply(this, args); }); } else { return _super[Symbol.replace].call(this, str, substitution); } }; function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { groups[name] = result[g[name]]; return groups; }, Object.create(null)); } return _wrapRegExp.apply(this, arguments); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function e(e, n, r, t) {
  return new (r || (r = Promise))(function (o, a) {
    function i(e) {
      try {
        c(t.next(e));
      } catch (e) {
        a(e);
      }
    }

    function u(e) {
      try {
        c(t.throw(e));
      } catch (e) {
        a(e);
      }
    }

    function c(e) {
      var n;
      e.done ? o(e.value) : (n = e.value, n instanceof r ? n : new r(function (e) {
        e(n);
      })).then(i, u);
    }

    c((t = t.apply(e, n || [])).next());
  });
}

function n(e, n) {
  var r,
      t,
      o,
      a,
      i = {
    label: 0,
    sent: function sent() {
      if (1 & o[0]) throw o[1];
      return o[1];
    },
    trys: [],
    ops: []
  };
  return a = {
    next: u(0),
    throw: u(1),
    return: u(2)
  }, "function" == typeof Symbol && (a[Symbol.iterator] = function () {
    return this;
  }), a;

  function u(u) {
    return function (c) {
      return function (u) {
        if (r) throw new TypeError("Generator is already executing.");

        for (; a && (a = 0, u[0] && (i = 0)), i;) {
          try {
            if (r = 1, t && (o = 2 & u[0] ? t.return : u[0] ? t.throw || ((o = t.return) && o.call(t), 0) : t.next) && !(o = o.call(t, u[1])).done) return o;

            switch (t = 0, o && (u = [2 & u[0], o.value]), u[0]) {
              case 0:
              case 1:
                o = u;
                break;

              case 4:
                return i.label++, {
                  value: u[1],
                  done: !1
                };

              case 5:
                i.label++, t = u[1], u = [0];
                continue;

              case 7:
                u = i.ops.pop(), i.trys.pop();
                continue;

              default:
                if (!(o = i.trys, (o = o.length > 0 && o[o.length - 1]) || 6 !== u[0] && 2 !== u[0])) {
                  i = 0;
                  continue;
                }

                if (3 === u[0] && (!o || u[1] > o[0] && u[1] < o[3])) {
                  i.label = u[1];
                  break;
                }

                if (6 === u[0] && i.label < o[1]) {
                  i.label = o[1], o = u;
                  break;
                }

                if (o && i.label < o[2]) {
                  i.label = o[2], i.ops.push(u);
                  break;
                }

                o[2] && i.ops.pop(), i.trys.pop();
                continue;
            }

            u = n.call(e, i);
          } catch (e) {
            u = [6, e], t = 0;
          } finally {
            r = o = 0;
          }
        }

        if (5 & u[0]) throw u[1];
        return {
          value: u[0] ? u[1] : void 0,
          done: !0
        };
      }([u, c]);
    };
  }
}

"function" == typeof SuppressedError && SuppressedError;
var r = {
  exclude: [],
  include: [],
  logging: !0
};

function t(e, n) {
  if (!["include", "exclude", "permissions_to_check", "retries", "timeout", "logging"].includes(e)) throw new Error("Unknown option " + e);
  if (["include", "exclude", "permissions_to_check"].includes(e) && (!Array.isArray(n) || !n.every(function (e) {
    return "string" == typeof e;
  }))) throw new Error("The value of the include, exclude and permissions_to_check must be an array of strings");
  if (["retries", "timeout"].includes(e) && "number" != typeof n) throw new Error("The value of retries must be a number");
  r[e] = n;
}

var o = {},
    a = {
  timeout: "true"
},
    i = function i(e, n) {
  "undefined" != typeof window && (o[e] = n);
},
    u = function u() {
  return Object.fromEntries(Object.entries(o).filter(function (e) {
    var n,
        t = e[0];
    return !(null === (n = null == r ? void 0 : r.exclude) || void 0 === n ? void 0 : n.includes(t));
  }).filter(function (e) {
    var n,
        t,
        o,
        a,
        i = e[0];
    return (null === (n = null == r ? void 0 : r.include) || void 0 === n ? void 0 : n.some(function (e) {
      return e.includes(".");
    })) ? null === (t = null == r ? void 0 : r.include) || void 0 === t ? void 0 : t.some(function (e) {
      return e.startsWith(i);
    }) : 0 === (null === (o = null == r ? void 0 : r.include) || void 0 === o ? void 0 : o.length) || (null === (a = null == r ? void 0 : r.include) || void 0 === a ? void 0 : a.includes(i));
  }).map(function (e) {
    return [e[0], (0, e[1])()];
  }));
};

function c(e) {
  return e ^= e >>> 16, e = Math.imul(e, 2246822507), e ^= e >>> 13, e = Math.imul(e, 3266489909), (e ^= e >>> 16) >>> 0;
}

var s = new Uint32Array([597399067, 2869860233, 951274213, 2716044179]);

function l(e, n) {
  return e << n | e >>> 32 - n;
}

function d(e, n) {
  var r;
  if (void 0 === n && (n = 0), n = n ? 0 | n : 0, "string" == typeof e && (r = e, e = new TextEncoder().encode(r).buffer), !(e instanceof ArrayBuffer)) throw new TypeError("Expected key to be ArrayBuffer or string");
  var t = new Uint32Array([n, n, n, n]);
  !function (e, n) {
    for (var r = e.byteLength / 16 | 0, t = new Uint32Array(e, 0, 4 * r), o = 0; o < r; o++) {
      var a = t.subarray(4 * o, 4 * (o + 1));
      a[0] = Math.imul(a[0], s[0]), a[0] = l(a[0], 15), a[0] = Math.imul(a[0], s[1]), n[0] = n[0] ^ a[0], n[0] = l(n[0], 19), n[0] = n[0] + n[1], n[0] = Math.imul(n[0], 5) + 1444728091, a[1] = Math.imul(a[1], s[1]), a[1] = l(a[1], 16), a[1] = Math.imul(a[1], s[2]), n[1] = n[1] ^ a[1], n[1] = l(n[1], 17), n[1] = n[1] + n[2], n[1] = Math.imul(n[1], 5) + 197830471, a[2] = Math.imul(a[2], s[2]), a[2] = l(a[2], 17), a[2] = Math.imul(a[2], s[3]), n[2] = n[2] ^ a[2], n[2] = l(n[2], 15), n[2] = n[2] + n[3], n[2] = Math.imul(n[2], 5) + 2530024501, a[3] = Math.imul(a[3], s[3]), a[3] = l(a[3], 18), a[3] = Math.imul(a[3], s[0]), n[3] = n[3] ^ a[3], n[3] = l(n[3], 13), n[3] = n[3] + n[0], n[3] = Math.imul(n[3], 5) + 850148119;
    }
  }(e, t), function (e, n) {
    var r = e.byteLength / 16 | 0,
        t = e.byteLength % 16,
        o = new Uint32Array(4),
        a = new Uint8Array(e, 16 * r, t);

    switch (t) {
      case 15:
        o[3] = o[3] ^ a[14] << 16;

      case 14:
        o[3] = o[3] ^ a[13] << 8;

      case 13:
        o[3] = o[3] ^ a[12] << 0, o[3] = Math.imul(o[3], s[3]), o[3] = l(o[3], 18), o[3] = Math.imul(o[3], s[0]), n[3] = n[3] ^ o[3];

      case 12:
        o[2] = o[2] ^ a[11] << 24;

      case 11:
        o[2] = o[2] ^ a[10] << 16;

      case 10:
        o[2] = o[2] ^ a[9] << 8;

      case 9:
        o[2] = o[2] ^ a[8] << 0, o[2] = Math.imul(o[2], s[2]), o[2] = l(o[2], 17), o[2] = Math.imul(o[2], s[3]), n[2] = n[2] ^ o[2];

      case 8:
        o[1] = o[1] ^ a[7] << 24;

      case 7:
        o[1] = o[1] ^ a[6] << 16;

      case 6:
        o[1] = o[1] ^ a[5] << 8;

      case 5:
        o[1] = o[1] ^ a[4] << 0, o[1] = Math.imul(o[1], s[1]), o[1] = l(o[1], 16), o[1] = Math.imul(o[1], s[2]), n[1] = n[1] ^ o[1];

      case 4:
        o[0] = o[0] ^ a[3] << 24;

      case 3:
        o[0] = o[0] ^ a[2] << 16;

      case 2:
        o[0] = o[0] ^ a[1] << 8;

      case 1:
        o[0] = o[0] ^ a[0] << 0, o[0] = Math.imul(o[0], s[0]), o[0] = l(o[0], 15), o[0] = Math.imul(o[0], s[1]), n[0] = n[0] ^ o[0];
    }
  }(e, t), function (e, n) {
    n[0] = n[0] ^ e.byteLength, n[1] = n[1] ^ e.byteLength, n[2] = n[2] ^ e.byteLength, n[3] = n[3] ^ e.byteLength, n[0] = n[0] + n[1] | 0, n[0] = n[0] + n[2] | 0, n[0] = n[0] + n[3] | 0, n[1] = n[1] + n[0] | 0, n[2] = n[2] + n[0] | 0, n[3] = n[3] + n[0] | 0, n[0] = c(n[0]), n[1] = c(n[1]), n[2] = c(n[2]), n[3] = c(n[3]), n[0] = n[0] + n[1] | 0, n[0] = n[0] + n[2] | 0, n[0] = n[0] + n[3] | 0, n[1] = n[1] + n[0] | 0, n[2] = n[2] + n[0] | 0, n[3] = n[3] + n[0] | 0;
  }(e, t);
  var o = new Uint8Array(t.buffer);
  return Array.from(o).map(function (e) {
    return e.toString(16).padStart(2, "0");
  }).join("");
}

function f(e, n) {
  return new Promise(function (r) {
    setTimeout(function () {
      return r(n);
    }, e);
  });
}

function h(e, n, r) {
  return Promise.all(e.map(function (e) {
    var t = performance.now();
    return Promise.race([e.then(function (e) {
      return {
        value: e,
        elapsed: performance.now() - t
      };
    }), f(n, r).then(function (e) {
      return {
        value: e,
        elapsed: performance.now() - t
      };
    })]);
  }));
}

function m(e, n, r) {
  return Promise.all(e.map(function (e) {
    return Promise.race([e, f(n, r)]);
  }));
}

var v = "0.19.1";

function g() {
  return v;
}

function p() {
  return e(this, void 0, void 0, function () {
    var e, t, o, i, c;
    return n(this, function (n) {
      switch (n.label) {
        case 0:
          return n.trys.push([0, 2,, 3]), e = u(), t = Object.keys(e), [4, m(Object.values(e), (null == r ? void 0 : r.timeout) || 1e3, a)];

        case 1:
          return o = n.sent(), i = o.filter(function (e) {
            return void 0 !== e;
          }), c = {}, i.forEach(function (e, n) {
            c[t[n]] = e;
          }), [2, w(c, r.exclude || [], r.include || [], "")];

        case 2:
          throw n.sent();

        case 3:
          return [2];
      }
    });
  });
}

function w(e, n, r, t) {
  void 0 === t && (t = "");

  for (var o = {}, a = function a(e, _a) {
    var i = t + e + ".";

    if ("object" != _typeof(_a) || Array.isArray(_a)) {
      var u = n.some(function (e) {
        return i.startsWith(e);
      }),
          c = r.some(function (e) {
        return i.startsWith(e);
      });
      u && !c || (o[e] = _a);
    } else {
      var s = w(_a, n, r, i);
      Object.keys(s).length > 0 && (o[e] = s);
    }
  }, i = 0, u = Object.entries(e); i < u.length; i++) {
    var c = u[i];
    a(c[0], c[1]);
  }

  return o;
}

function y(t) {
  return e(this, void 0, void 0, function () {
    var o, a;
    return n(this, function (i) {
      switch (i.label) {
        case 0:
          return i.trys.push([0, 2,, 3]), [4, p()];

        case 1:
          return o = i.sent(), a = d(JSON.stringify(o)), Math.random() < .001 && r.logging && function (r, t) {
            e(this, void 0, void 0, function () {
              var e, o;
              return n(this, function (n) {
                switch (n.label) {
                  case 0:
                    if (e = "https://logging.thumbmarkjs.com/v1/log", o = {
                      thumbmark: r,
                      components: t,
                      version: g()
                    }, sessionStorage.getItem("_tmjs_l")) return [3, 4];
                    sessionStorage.setItem("_tmjs_l", "1"), n.label = 1;

                  case 1:
                    return n.trys.push([1, 3,, 4]), [4, fetch(e, {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json"
                      },
                      body: JSON.stringify(o)
                    })];

                  case 2:
                  case 3:
                    return n.sent(), [3, 4];

                  case 4:
                    return [2];
                }
              });
            });
          }(a, o), t ? [2, {
            hash: a.toString(),
            data: o
          }] : [2, a.toString()];

        case 2:
          throw i.sent();

        case 3:
          return [2];
      }
    });
  });
}

function b() {
  return e(this, void 0, void 0, function () {
    var e, t, o, i;
    return n(this, function (n) {
      switch (n.label) {
        case 0:
          return n.trys.push([0, 2,, 3]), e = u(), t = Object.keys(e), [4, h(Object.values(e), (null == r ? void 0 : r.timeout) || 1e3, a)];

        case 1:
          return o = n.sent(), i = {
            elapsed: {}
          }, o.forEach(function (e, n) {
            i[t[n]] = e.value, i.elapsed[t[n]] = e.elapsed;
          }), [2, i];

        case 2:
          throw n.sent();

        case 3:
          return [2];
      }
    });
  });
}

function S(e) {
  for (var n = 0, r = 0; r < e.length; ++r) {
    n += Math.abs(e[r]);
  }

  return n;
}

function M(e, n, r) {
  for (var t = [], o = 0; o < e[0].data.length; o++) {
    for (var a = [], i = 0; i < e.length; i++) {
      a.push(e[i].data[o]);
    }

    t.push(E(a));
  }

  var u = new Uint8ClampedArray(t);
  return new ImageData(u, n, r);
}

function E(e) {
  if (0 === e.length) return 0;

  for (var n = {}, r = 0, t = e; r < t.length; r++) {
    n[a = t[r]] = (n[a] || 0) + 1;
  }

  var o = e[0];

  for (var a in n) {
    n[a] > n[o] && (o = parseInt(a, 10));
  }

  return o;
}

function P() {
  if ("undefined" == typeof navigator) return {
    name: "unknown",
    version: "unknown"
  };

  for (var e = navigator.userAgent, n = {
    Edg: "Edge",
    OPR: "Opera"
  }, r = 0, t = [/*#__PURE__*/_wrapRegExp(/(Edge|Edg)\/([0-9]+(?:\.[0-9]+)?)/, {
    name: 1,
    version: 2
  }), /*#__PURE__*/_wrapRegExp(/((?:Chrome|Chromium|OPR|Opera|Vivaldi|Brave))\/([0-9]+(?:\.[0-9]+)?)/, {
    name: 1,
    version: 2
  }), /*#__PURE__*/_wrapRegExp(/((?:Firefox|Waterfox|Iceweasel|IceCat))\/([0-9]+(?:\.[0-9]+)?)/, {
    name: 1,
    version: 2
  }), /*#__PURE__*/_wrapRegExp(/(Safari)\/([0-9]+(?:\.[0-9]+)?)/, {
    name: 1,
    version: 2
  }), /*#__PURE__*/_wrapRegExp(/(MSIE|Trident|IEMobile).+?([0-9]+(?:\.[0-9]+)?)/, {
    name: 1,
    version: 2
  }), /*#__PURE__*/_wrapRegExp(/([A-Za-z]+)\/([0-9]+(?:\.[0-9]+)?)/, {
    name: 1,
    version: 2
  }), /*#__PURE__*/_wrapRegExp(/(SamsungBrowser)\/([0-9]+(?:\.[0-9]+)?)/, {
    name: 1,
    version: 2
  })]; r < t.length; r++) {
    var o = t[r],
        a = e.match(o);
    if (a && a.groups) return {
      name: n[a.groups.name] || a.groups.name,
      version: a.groups.version
    };
  }

  return {
    name: "unknown",
    version: "unknown"
  };
}

i("audio", function () {
  return e(this, void 0, void 0, function () {
    return n(this, function (e) {
      return [2, new Promise(function (e, n) {
        try {
          var r = new (window.OfflineAudioContext || window.webkitOfflineAudioContext)(1, 5e3, 44100),
              t = r.createBufferSource(),
              o = r.createOscillator();
          o.frequency.value = 1e3;
          var a,
              i = r.createDynamicsCompressor();
          i.threshold.value = -50, i.knee.value = 40, i.ratio.value = 12, i.attack.value = 0, i.release.value = .2, o.connect(i), i.connect(r.destination), o.start(), r.oncomplete = function (n) {
            a = n.renderedBuffer.getChannelData(0), e({
              sampleHash: S(a),
              oscillator: o.type,
              maxChannels: r.destination.maxChannelCount,
              channelCountMode: t.channelCountMode
            });
          }, r.startRendering();
        } catch (e) {
          console.error("Error creating audio fingerprint:", e), n(e);
        }
      })];
    });
  });
});
var A = "SamsungBrowser" !== P().name ? 1 : 3,
    C = 280,
    x = 20;
"Firefox" != P().name && i("canvas", function () {
  return document.createElement("canvas").getContext("2d"), new Promise(function (e) {
    var n = Array.from({
      length: A
    }, function () {
      return function () {
        var e = document.createElement("canvas"),
            n = e.getContext("2d");
        if (!n) return new ImageData(1, 1);
        e.width = C, e.height = x;
        var r = n.createLinearGradient(0, 0, e.width, e.height);
        r.addColorStop(0, "red"), r.addColorStop(1 / 6, "orange"), r.addColorStop(2 / 6, "yellow"), r.addColorStop(.5, "green"), r.addColorStop(4 / 6, "blue"), r.addColorStop(5 / 6, "indigo"), r.addColorStop(1, "violet"), n.fillStyle = r, n.fillRect(0, 0, e.width, e.height);
        var t = "Random Text WMwmil10Oo";
        n.font = "23.123px Arial", n.fillStyle = "black", n.fillText(t, -5, 15), n.fillStyle = "rgba(0, 0, 255, 0.5)", n.fillText(t, -3.3, 17.7), n.beginPath(), n.moveTo(0, 0), n.lineTo(2 * e.width / 7, e.height), n.strokeStyle = "white", n.lineWidth = 2, n.stroke();
        var o = n.getImageData(0, 0, e.width, e.height);
        return o;
      }();
    });
    e({
      commonImageDataHash: d(M(n, C, x).data.toString()).toString()
    });
  });
});
var T,
    k = ["Arial", "Arial Black", "Arial Narrow", "Arial Rounded MT", "Arimo", "Archivo", "Barlow", "Bebas Neue", "Bitter", "Bookman", "Calibri", "Cabin", "Candara", "Century", "Century Gothic", "Comic Sans MS", "Constantia", "Courier", "Courier New", "Crimson Text", "DM Mono", "DM Sans", "DM Serif Display", "DM Serif Text", "Dosis", "Droid Sans", "Exo", "Fira Code", "Fira Sans", "Franklin Gothic Medium", "Garamond", "Geneva", "Georgia", "Gill Sans", "Helvetica", "Impact", "Inconsolata", "Indie Flower", "Inter", "Josefin Sans", "Karla", "Lato", "Lexend", "Lucida Bright", "Lucida Console", "Lucida Sans Unicode", "Manrope", "Merriweather", "Merriweather Sans", "Montserrat", "Myriad", "Noto Sans", "Nunito", "Nunito Sans", "Open Sans", "Optima", "Orbitron", "Oswald", "Pacifico", "Palatino", "Perpetua", "PT Sans", "PT Serif", "Poppins", "Prompt", "Public Sans", "Quicksand", "Rajdhani", "Recursive", "Roboto", "Roboto Condensed", "Rockwell", "Rubik", "Segoe Print", "Segoe Script", "Segoe UI", "Sora", "Source Sans Pro", "Space Mono", "Tahoma", "Taviraj", "Times", "Times New Roman", "Titillium Web", "Trebuchet MS", "Ubuntu", "Varela Round", "Verdana", "Work Sans"],
    R = ["monospace", "sans-serif", "serif"];

function I(e, n) {
  if (!e) throw new Error("Canvas context not supported");
  return e.font, e.font = "72px ".concat(n), e.measureText("WwMmLli0Oo").width;
}

function O() {
  var e,
      n = document.createElement("canvas"),
      r = null !== (e = n.getContext("webgl")) && void 0 !== e ? e : n.getContext("experimental-webgl");
  if (r && "getParameter" in r) try {
    var t = (r.getParameter(r.VENDOR) || "").toString(),
        o = (r.getParameter(r.RENDERER) || "").toString(),
        a = {
      vendor: t,
      renderer: o,
      version: (r.getParameter(r.VERSION) || "").toString(),
      shadingLanguageVersion: (r.getParameter(r.SHADING_LANGUAGE_VERSION) || "").toString()
    };

    if (!o.length || !t.length) {
      var i = r.getExtension("WEBGL_debug_renderer_info");

      if (i) {
        var u = (r.getParameter(i.UNMASKED_VENDOR_WEBGL) || "").toString(),
            c = (r.getParameter(i.UNMASKED_RENDERER_WEBGL) || "").toString();
        u && (a.vendorUnmasked = u), c && (a.rendererUnmasked = c);
      }
    }

    return a;
  } catch (e) {}
  return "undefined";
}

function _() {
  var e = new Float32Array(1),
      n = new Uint8Array(e.buffer);
  return e[0] = 1 / 0, e[0] = e[0] - e[0], n[3];
}

function L(e, n) {
  var r = {};
  return n.forEach(function (n) {
    var t = function (e) {
      if (0 === e.length) return null;
      var n = {};
      e.forEach(function (e) {
        var r = String(e);
        n[r] = (n[r] || 0) + 1;
      });
      var r = e[0],
          t = 1;
      return Object.keys(n).forEach(function (e) {
        n[e] > t && (r = e, t = n[e]);
      }), r;
    }(e.map(function (e) {
      return n in e ? e[n] : void 0;
    }).filter(function (e) {
      return void 0 !== e;
    }));

    t && (r[n] = t);
  }), r;
}

function D() {
  var e = [],
      n = {
    "prefers-contrast": ["high", "more", "low", "less", "forced", "no-preference"],
    "any-hover": ["hover", "none"],
    "any-pointer": ["none", "coarse", "fine"],
    pointer: ["none", "coarse", "fine"],
    hover: ["hover", "none"],
    update: ["fast", "slow"],
    "inverted-colors": ["inverted", "none"],
    "prefers-reduced-motion": ["reduce", "no-preference"],
    "prefers-reduced-transparency": ["reduce", "no-preference"],
    scripting: ["none", "initial-only", "enabled"],
    "forced-colors": ["active", "none"]
  };
  return Object.keys(n).forEach(function (r) {
    n[r].forEach(function (n) {
      matchMedia("(".concat(r, ": ").concat(n, ")")).matches && e.push("".concat(r, ": ").concat(n));
    });
  }), e;
}

function B() {
  if ("https:" === window.location.protocol && "function" == typeof window.ApplePaySession) try {
    for (var e = window.ApplePaySession.supportsVersion, n = 15; n > 0; n--) {
      if (e(n)) return n;
    }
  } catch (e) {
    return 0;
  }
  return 0;
}

"Firefox" != P().name && i("fonts", function () {
  var r = this;
  return new Promise(function (t, o) {
    try {
      !function (r) {
        var t;
        e(this, void 0, void 0, function () {
          var e, o, a;
          return n(this, function (n) {
            switch (n.label) {
              case 0:
                return document.body ? [3, 2] : [4, (i = 50, new Promise(function (e) {
                  return setTimeout(e, i, u);
                }))];

              case 1:
                return n.sent(), [3, 0];

              case 2:
                if ((e = document.createElement("iframe")).setAttribute("frameBorder", "0"), (o = e.style).setProperty("position", "fixed"), o.setProperty("display", "block", "important"), o.setProperty("visibility", "visible"), o.setProperty("border", "0"), o.setProperty("opacity", "0"), e.src = "about:blank", document.body.appendChild(e), !(a = e.contentDocument || (null === (t = e.contentWindow) || void 0 === t ? void 0 : t.document))) throw new Error("Iframe document is not accessible");
                return r({
                  iframe: a
                }), setTimeout(function () {
                  document.body.removeChild(e);
                }, 0), [2];
            }

            var i, u;
          });
        });
      }(function (o) {
        var a = o.iframe;
        return e(r, void 0, void 0, function () {
          var e, r, o, i;
          return n(this, function (n) {
            return "Hello, world!", e = a.createElement("canvas"), r = e.getContext("2d"), o = R.map(function (e) {
              return I(r, e);
            }), i = {}, k.forEach(function (e) {
              var n = I(r, e);
              o.includes(n) || (i[e] = n);
            }), t(i), [2];
          });
        });
      });
    } catch (e) {
      o({
        error: "unsupported"
      });
    }
  });
}), i("hardware", function () {
  return new Promise(function (e, n) {
    var r = void 0 !== navigator.deviceMemory ? navigator.deviceMemory : 0,
        t = window.performance && window.performance.memory ? window.performance.memory : 0;
    e({
      videocard: O(),
      architecture: _(),
      deviceMemory: r.toString() || "undefined",
      jsHeapSizeLimit: t.jsHeapSizeLimit || 0
    });
  });
}), i("locales", function () {
  return new Promise(function (e) {
    e({
      languages: navigator.language,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
  });
}), i("permissions", function () {
  return e(this, void 0, void 0, function () {
    var t;
    return n(this, function (o) {
      return T = (null == r ? void 0 : r.permissions_to_check) || ["accelerometer", "accessibility", "accessibility-events", "ambient-light-sensor", "background-fetch", "background-sync", "bluetooth", "camera", "clipboard-read", "clipboard-write", "device-info", "display-capture", "gyroscope", "geolocation", "local-fonts", "magnetometer", "microphone", "midi", "nfc", "notifications", "payment-handler", "persistent-storage", "push", "speaker", "storage-access", "top-level-storage-access", "window-management", "query"], t = Array.from({
        length: (null == r ? void 0 : r.retries) || 3
      }, function () {
        return function () {
          return e(this, void 0, void 0, function () {
            var e, r, t, o, a;
            return n(this, function (n) {
              switch (n.label) {
                case 0:
                  e = {}, r = 0, t = T, n.label = 1;

                case 1:
                  if (!(r < t.length)) return [3, 6];
                  o = t[r], n.label = 2;

                case 2:
                  return n.trys.push([2, 4,, 5]), [4, navigator.permissions.query({
                    name: o
                  })];

                case 3:
                  return a = n.sent(), e[o] = a.state.toString(), [3, 5];

                case 4:
                  return n.sent(), [3, 5];

                case 5:
                  return r++, [3, 1];

                case 6:
                  return [2, e];
              }
            });
          });
        }();
      }), [2, Promise.all(t).then(function (e) {
        return L(e, T);
      })];
    });
  });
}), i("plugins", function () {
  var e = [];
  if (navigator.plugins) for (var n = 0; n < navigator.plugins.length; n++) {
    var r = navigator.plugins[n];
    e.push([r.name, r.filename, r.description].join("|"));
  }
  return new Promise(function (n) {
    n({
      plugins: e
    });
  });
}), i("screen", function () {
  return new Promise(function (e) {
    e({
      is_touchscreen: navigator.maxTouchPoints > 0,
      maxTouchPoints: navigator.maxTouchPoints,
      colorDepth: screen.colorDepth,
      mediaMatches: D()
    });
  });
}), i("system", function () {
  return new Promise(function (e) {
    var n = P();
    e({
      platform: window.navigator.platform,
      cookieEnabled: window.navigator.cookieEnabled,
      productSub: navigator.productSub,
      product: navigator.product,
      useragent: navigator.userAgent,
      hardwareConcurrency: navigator.hardwareConcurrency,
      browser: {
        name: n.name,
        version: n.version
      },
      applePayVersion: B()
    });
  });
});
var U,
    F = "SamsungBrowser" !== P().name ? 1 : 3,
    N = null;
i("webgl", function () {
  return e(this, void 0, void 0, function () {
    var e;
    return n(this, function (n) {
      "undefined" != typeof document && ((U = document.createElement("canvas")).width = 200, U.height = 100, N = U.getContext("webgl"));

      try {
        if (!N) throw new Error("WebGL not supported");
        return e = Array.from({
          length: F
        }, function () {
          return function () {
            try {
              if (!N) throw new Error("WebGL not supported");
              var e = "\n          attribute vec2 position;\n          void main() {\n              gl_Position = vec4(position, 0.0, 1.0);\n          }\n      ",
                  n = "\n          precision mediump float;\n          void main() {\n              gl_FragColor = vec4(0.812, 0.195, 0.553, 0.921); // Set line color\n          }\n      ",
                  r = N.createShader(N.VERTEX_SHADER),
                  t = N.createShader(N.FRAGMENT_SHADER);
              if (!r || !t) throw new Error("Failed to create shaders");
              if (N.shaderSource(r, e), N.shaderSource(t, n), N.compileShader(r), !N.getShaderParameter(r, N.COMPILE_STATUS)) throw new Error("Vertex shader compilation failed: " + N.getShaderInfoLog(r));
              if (N.compileShader(t), !N.getShaderParameter(t, N.COMPILE_STATUS)) throw new Error("Fragment shader compilation failed: " + N.getShaderInfoLog(t));
              var o = N.createProgram();
              if (!o) throw new Error("Failed to create shader program");
              if (N.attachShader(o, r), N.attachShader(o, t), N.linkProgram(o), !N.getProgramParameter(o, N.LINK_STATUS)) throw new Error("Shader program linking failed: " + N.getProgramInfoLog(o));
              N.useProgram(o);

              for (var a = 137, i = new Float32Array(4 * a), u = 2 * Math.PI / a, c = 0; c < a; c++) {
                var s = c * u;
                i[4 * c] = 0, i[4 * c + 1] = 0, i[4 * c + 2] = Math.cos(s) * (U.width / 2), i[4 * c + 3] = Math.sin(s) * (U.height / 2);
              }

              var l = N.createBuffer();
              N.bindBuffer(N.ARRAY_BUFFER, l), N.bufferData(N.ARRAY_BUFFER, i, N.STATIC_DRAW);
              var d = N.getAttribLocation(o, "position");
              N.enableVertexAttribArray(d), N.vertexAttribPointer(d, 2, N.FLOAT, !1, 0, 0), N.viewport(0, 0, U.width, U.height), N.clearColor(0, 0, 0, 1), N.clear(N.COLOR_BUFFER_BIT), N.drawArrays(N.LINES, 0, 2 * a);
              var f = new Uint8ClampedArray(U.width * U.height * 4);
              return N.readPixels(0, 0, U.width, U.height, N.RGBA, N.UNSIGNED_BYTE, f), new ImageData(f, U.width, U.height);
            } catch (e) {
              return new ImageData(1, 1);
            } finally {
              N && (N.bindBuffer(N.ARRAY_BUFFER, null), N.useProgram(null), N.viewport(0, 0, N.drawingBufferWidth, N.drawingBufferHeight), N.clearColor(0, 0, 0, 0));
            }
          }();
        }), [2, {
          commonImageHash: d(M(e, U.width, U.height).data.toString()).toString()
        }];
      } catch (e) {
        return [2, {
          webgl: "unsupported"
        }];
      }

      return [2];
    });
  });
});

var j = function j(e, n, r, t) {
  for (var o = (r - n) / t, a = 0, i = 0; i < t; i++) {
    a += e(n + (i + .5) * o);
  }

  return a * o;
};

i("math", function () {
  return e(void 0, void 0, void 0, function () {
    return n(this, function (e) {
      return [2, {
        acos: Math.acos(.5),
        asin: j(Math.asin, -1, 1, 97),
        atan: j(Math.atan, -1, 1, 97),
        cos: j(Math.cos, 0, Math.PI, 97),
        cosh: Math.cosh(9 / 7),
        e: Math.E,
        largeCos: Math.cos(1e20),
        largeSin: Math.sin(1e20),
        largeTan: Math.tan(1e20),
        log: Math.log(1e3),
        pi: Math.PI,
        sin: j(Math.sin, -Math.PI, Math.PI, 97),
        sinh: j(Math.sinh, -9 / 7, 7 / 9, 97),
        sqrt: Math.sqrt(2),
        tan: j(Math.tan, 0, 2 * Math.PI, 97),
        tanh: j(Math.tanh, -9 / 7, 7 / 9, 97)
      }];
    });
  });
});
export { y as getFingerprint, p as getFingerprintData, b as getFingerprintPerformance, g as getVersion, i as includeComponent, t as setOption };